
import axios from "axios";
import { handleApiError } from "@/utils/errorHandler";
import { getCurrentClientData } from "./authServices";

export interface SubscriptionStatus {
  isPro: boolean;
  planId: string;
  planName: string;
  nextBillingDate: string | null;
  features: string[];
}

export const getCurrentSubscription = async (): Promise<SubscriptionStatus> => {
  try {
    const { token } = getCurrentClientData();
    const api = axios.create({
      baseURL: `${import.meta.env.VITE_API_BASE_URL}`,
      headers: {
        Authorization: token,
      },
    });
    
    const response = await api.post("/subscription/v1/current");
    return response.data.body;
  } catch (error: any) {
    // For demo purposes, return a mock subscription
    console.warn("Using mock subscription data");
    return {
      isPro: localStorage.getItem("isPro") === "true",
      planId: localStorage.getItem("isPro") === "true" ? "pro" : "free",
      planName: localStorage.getItem("isPro") === "true" ? "Pro Plan" : "Free Plan",
      nextBillingDate: localStorage.getItem("isPro") === "true" ? "2025-05-24" : null,
      features: localStorage.getItem("isPro") === "true" ? 
        ["Multiple ticket types", "Event analytics", "Custom registration fields"] : 
        ["Basic event creation", "Single ticket type", "Limited registrations"]
    };
  }
};

export const upgradeToPro = async (): Promise<boolean> => {
  try {
    // In a real app, this would redirect to a payment gateway or subscription API
    // For demo purposes, we'll just set a flag in localStorage
    localStorage.setItem("isPro", "true");
    return true;
  } catch (error: any) {
    return handleApiError(error, "Error upgrading subscription");
  }
};

export const cancelSubscription = async (): Promise<boolean> => {
  try {
    // In a real app, this would call an API to cancel the subscription
    // For demo purposes, we'll just remove the flag from localStorage
    localStorage.setItem("isPro", "false");
    return true;
  } catch (error: any) {
    return handleApiError(error, "Error cancelling subscription");
  }
};
